(function () {
    const loadedScripts = new Set();  // Track loaded scripts to prevent reloading

    // Default debug mode (can be toggled per call)
    window.ScriptController = {
        // Conditional logging based on debug mode
        log: function (message, debug) {
            if (debug) {
                console.log(message);
            }
        },

        // Load multiple scripts with better control
        loadScripts: function (urls, options = {}) {
            const scriptsToLoad = Array.isArray(urls) ? urls : [urls];
            const loadPromises = [];

            scriptsToLoad.forEach(url => {
                if (loadedScripts.has(url)) {
                    this.log(`✅ Already loaded: ${url}`, options.debug);
                    return;  // Skip if already loaded
                }

                const loadPromise = new Promise((resolve, reject) => {
                    const script = document.createElement("script");
                    script.src = url;
                    script.async = options.async ?? true;
                    script.defer = options.defer ?? true;

                    script.onload = () => {
                        loadedScripts.add(url);
                        this.log(`✅ Loaded: ${url}`, options.debug);
                        resolve(url);

                        if (typeof options.onload === "function") {
                            options.onload(url);  // Call the onload callback if defined
                        }
                    };

                    script.onerror = () => {
                        console.error(`❌ Failed to load: ${url}`);
                        reject(new Error(`Failed to load: ${url}`));
                    };

                    document.head.appendChild(script);
                });

                loadPromises.push(loadPromise);
            });

            return Promise.all(loadPromises);  // Return promise that resolves when all scripts are loaded
        },

        // Run when DOM is ready
        runWhenDOMReady: function (callback) {
            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", callback);
            } else {
                callback();
            }
        },

        // Run when window is ready
        runWhenWindowReady: function (callback) {
            if (document.readyState === "complete") {
                callback();
            } else {
                window.addEventListener("load", callback);
            }
        },

        // Simplified load and callback handler with debug option
        loadAndRun: function (urls, options = {}) {
            this.loadScripts(urls, options).then(() => {
                if (options.runOn === 'DOMContentLoaded') {
                    this.runWhenDOMReady(() => {
                        this.log("DOM loaded for scripts", options.debug);  // Log only if debug is true
                        options.callback();
                    });
                } else if (options.runOn === 'load') {
                    this.runWhenWindowReady(() => {
                        this.log("Window loaded for scripts", options.debug);  // Log only if debug is true
                        options.callback();
                    });
                }
            });
        }
    };

})();